import umlConst from '../../Types/UmlConsts.js';

// Generic canvas-level geometry/DOM helpers — not shape-specific (see ShapeHitTester
// for shape-at-point, ConnectorSegmentFinder for connector-line geometry).
class CanvasGeometry {
    /**
     * Snaps a world coordinate to the nearest grid line.
     * @param {number} value
     * @param {number} [gridSize] - resolve via userSettingsEngine.resolve('umlWorkspace.gridSize')
     * @returns {number}
     */
    static snapToGrid(value, gridSize = umlConst.SNAP_GRID_SIZE) {
        return Math.round(value / gridSize) * gridSize;
    }

    /**
     * True if target is the canvas element itself or the world-wrapper around it,
     * not a shape/connector/handle inside it.
     * @param {EventTarget} target
     * @returns {boolean}
     */
    static isBackgroundElement(target) {
        return target.classList.contains('uml-canvas') || target.classList.contains('uml-canvas-world');
    }
}

export default CanvasGeometry;
